import { Observable } from 'rxjs'
import { filter, tap } from 'rxjs/operators'
import Member from 'iam/models/Member'

/**
 * Heap integration
 */
export function HeapIntegration(currentMember$: Observable<Member>) {
  return currentMember$.pipe(
    filter((member) => !member.email.toLowerCase().includes('e2e-')),
    filter((member) => !member.workspace.name.toLowerCase().includes('e2e-')),
    tap((member) => {
      if (window?.heap) {
        const heap = window.heap
        heap.identify(member.user.id)
        heap.addUserProperties({
          'First Name': member.givenName,
          'Last Name': member.familyName,
          email: member.email,
          Workspace: member.workspace.id,
        })
      }
    }),
  )
}
